import { VendorDTO } from 'wisestep-api';
import { formatLocation } from 'wisestep-base';

export const getVendorInfoDetailsArray = (vendor: VendorDTO) => {
  const detailsArray = [
    {
      label: 'Vendor Name',
      value: vendor.name,
    },
    {
      label: 'Vendor Email',
      value: vendor.email,
    },
    {
      label: 'Legal Name',
      value: vendor.legalName,
    },
    {
      label: 'Registration ID',
      value: vendor.registrationId,
    },
    {
      label: 'Location',
      value: vendor.location ? formatLocation(vendor.location) : 'Not Available',
    },
  ];
  return detailsArray;
};

export const vendorDefaultValues = {
  id: '',
  name: '',
  email: '',
  legalName: '',
  address: '',
  registrationId: '',
  location: {},
  active: false,
};
